
//Configuraciones para las peticiones http
export const SERVER_PATH = 'https://app.pems.io:3000';


export const AXIOS_CONFIG= (h) => {	
    let config = {
        headers: {
            'Cache-Control' : 'max-age=0, no-cache, no-store, must-revalidate', 
            'Expires' : 'Thu, 01 Jan 1970 00:00:00 GMT', 
            'Pragma' : 'no-cache',
            'Authorization': 'Bearer ' + localStorage.getItem('user_token')
        }
    }
    if(h===1)
    {
        config.responseType = 'arraybuffer'
    }
   return config
};


//Acciones para saber que tomar a la hora de abrir el dialogo de create project 
export const CREATE_PROJECT_MODEL_ACTION_CREATE = 0;
export const CREATE_PROJECT_MODEL_ACTION_EDIT   = 1;
export const CREATE_PROJECT_MODEL_ACTION_SHOW   = 2;

export const NODE_TYPE_COMPONENT    = 1;
export const NODE_TYPE_DELIVERABLE  = 2;
export const NODE_TYPE_WORKPACKAGE  = 3;

export const COST_TYPE_LABOR        = 1;
export const COST_TYPE_EQUIPMENT    = 2;
export const COST_TYPE_MATERIAL     = 3;
export const COST_TYPE_OTHER        = 4;
export const COST_TYPE_SUBCONTRACT  = 5;

//Roles
export const ROLE_SUPER     = 0;
export const ROLE_ADMIN     = 1;
export const ROLE_PM        = 2;
export const ROLE_VIEWER    = 3;


//Status project
export const STATUS_PROJECT_ACTIVE        = 1;
export const STATUS_PROJECT_PUBLISHED        = 2;




// WEBPACK FOOTER //
// ./src/features/common/redux/constantes.js